type Props = {
  height: number;
  width: number;
};

export const DisabledFeatureIcon = ({ height, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99991 4.08326L0.958247 6.12493C0.881858 6.20132 0.784636 6.23951 0.66658 6.23951C0.548525 6.23951 0.451302 6.20132 0.374914 6.12493C0.298525 6.04854 0.26033 5.95132 0.26033 5.83326C0.26033 5.71521 0.298525 5.61798 0.374914 5.5416L2.41658 3.49993L0.374914 1.45826C0.298525 1.38187 0.26033 1.28465 0.26033 1.1666C0.26033 1.04854 0.298525 0.951318 0.374914 0.874929C0.451302 0.79854 0.548525 0.760345 0.66658 0.760345C0.784636 0.760345 0.881858 0.79854 0.958247 0.874929L2.99991 2.9166L5.04158 0.874929C5.11797 0.79854 5.21519 0.760345 5.33325 0.760345C5.4513 0.760345 5.54852 0.79854 5.62491 0.874929C5.7013 0.951318 5.7395 1.04854 5.7395 1.1666C5.7395 1.28465 5.7013 1.38187 5.62491 1.45826L3.58325 3.49993L5.62491 5.5416C5.7013 5.61798 5.7395 5.71521 5.7395 5.83326C5.7395 5.95132 5.7013 6.04854 5.62491 6.12493C5.54852 6.20132 5.4513 6.23951 5.33325 6.23951C5.21519 6.23951 5.11797 6.20132 5.04158 6.12493L2.99991 4.08326Z"
        fill="#7E848E"
      />
    </svg>
  );
};
